import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";

const SessionCtx = createContext(null);

export function SessionProvider({ children }) {
  const [role, setRole] = useState(() => localStorage.getItem("tt_role") || null);
  const [userId, setUserId] = useState(() => localStorage.getItem("tt_user_id") || null);
  const [theme, setTheme] = useState(() => localStorage.getItem("tt_theme") || "calm");

  useEffect(() => {
    if (role) localStorage.setItem("tt_role", role);
    if (userId) localStorage.setItem("tt_user_id", userId);
    localStorage.setItem("tt_theme", theme);
  }, [role, userId, theme]);

  useEffect(() => {
    const root = document.documentElement;
    root.classList.remove("theme-high-contrast", "theme-warm");
    if (theme === "high_contrast") root.classList.add("theme-high-contrast");
    if (theme === "warm") root.classList.add("theme-warm");
  }, [theme]);

  const signOut = useCallback(() => {
    localStorage.removeItem("tt_role");
    localStorage.removeItem("tt_user_id");
    setRole(null);
    setUserId(null);
  }, []);

  const value = useMemo(
    () => ({ role, setRole, userId, setUserId, theme, setTheme, signOut }),
    [role, userId, theme, signOut]
  );

  return <SessionCtx.Provider value={value}>{children}</SessionCtx.Provider>;
}

export const useSession = () => useContext(SessionCtx);
